
document.addEventListener("DOMContentLoaded", function () {
    var elements = document.querySelectorAll(".in-view");
    var observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.intersectionRatio > 0) {
                entry.target.classList.add("animate");
            } else {
                entry.target.classList.remove("animate");
            }
           
            
		 
        });
    });
    elements.forEach((element) => {
        observer.observe(element);
    });

    // Toggle border on rc-widget when checkbox is checked
    var checkbox = document.getElementById("rc-checkbox1");
    if (checkbox) {
        var rcWidget = checkbox.closest(".rc-widget");
        if (rcWidget) {
            function updateBorder() {
                if (checkbox.checked) {
                    rcWidget.classList.add("rc-widget--checked");
                } else {
                    rcWidget.classList.remove("rc-widget--checked");
                }
            }
            
            // Initial check
            updateBorder();
            
            // Listen for changes
            checkbox.addEventListener("change", updateBorder);
        }
    }
});
